import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=0acc706a&scoped=true&"
import script from "./EditorText.vue?vue&type=script&lang=js&"
export * from "./EditorText.vue?vue&type=script&lang=js&"
import style0 from "./EditorText.vue?vue&type=style&index=0&id=0acc706a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc706a",
  null
  
)

export default component.exports